<modal #modal modalClass="agency-picker-modal">
  <modal-header>
    <div class="row w-100 mx-0">
        <h4 class="modal-title mb-4 px-0">Agencies</h4>
                <form (submit)="filterAgencies()" novalidate class="display-flex flex-row w-100 px-0">
                    <input type="text" placeholder="Search By Name" class="form-control me-2" [formControl]="searchBox">
                    <button type="submit" class="btn btn-primary">Search</button>
                </form>
    </div>
  </modal-header>
  <modal-body>
    <table-dynamic id="datatable-table"
                   class="table table-striped table-hover"
                   [currentPage]="currentPage"
                   [totalCount]="totalCount"
                   [headers]="headers"
                   (pageChanged)="setPage($event)"
                   (limitChange)="setLimit($event)">
      <tr *ngFor="let agency of agencies" [ngClass]="{selected: agency == selectedRow}" (click)="setClickedRow(agency)">
        <td>{{agency.agencyName}}</td>
      </tr>
    </table-dynamic>
  </modal-body>
  <modal-footer>
      <button *ngIf="showNoAgency" type="button" class="btn btn-danger me-auto" (click)="resetClicked()">No Agency</button>
      <button type="button" [disabled]="!selectedRow" class="btn btn-primary me-2" (click)="okClicked(selectedRow)">Ok</button>
      <button type="button" class="btn btn-default" (click)="cancelClicked()">Cancel</button>

  </modal-footer>
</modal>
